<template>
  <div>
    <v-dialog v-model="customerSearchDialogVueDialog" max-width="600">
      <v-card min-height="400">
        <v-card-title class="info text-white justify-between">
          {{ $t('customer.select_customer') }}
          <v-btn
            color="white"
            icon
            @click="onCancel"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-5">
          <!-- Content Space -->
          <v-text-field
            solo
            background-color="grey lighten-4"
            flat
            prepend-inner-icon="mdi-magnify"
            :label="$t('project.search_name_phone_email_citizen_id')"
            :placeholder="$t('project.search_name_phone_email_citizen_id')"
            hide-details=""
            @input="findCustomer"
            v-model="searchText">
          </v-text-field>
          <div class="mt-3">
            <div v-if="searchCustomers.length > 0" class="list-none divide-y">
              <div v-for="customer in searchCustomers" class="
                  px-3
                  py-1
                  cursor-pointer
                  normal-select
                  flex
                  justify-between
                  items-center
                " @click="selectCustomer(customer)">
                <div>
                  <div class="py-2">
                    <div class="text-xs">{{ $t('market.customer_name_and_company_not_space') }}</div>
                    <span v-if="customer.companyName">
                      {{ customer.companyName}}
                    </span>
                    {{ customer.firstName }}
                    {{ customer.lastName }}
                  </div>
                  <div class="text-sm">
                    <v-icon left size="15">mdi-phone</v-icon>
                    {{ $helper.telToString(customer.interTels, customer.tels, { separator: ", " }) }}
                  </div>
                </div>
                <div>
                  {{ typeString(customer.type) }}
                </div>
              </div>
            </div>
            <div v-else class="text-center py-5">
              <span class="font-bold">{{ $t('customer.search_customer_data') }}..</span>
            </div>
            <div v-if="isLoading">
              <v-progress-linear indeterminate color="green" class="mb-3"></v-progress-linear>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      color="error"
      v-model="isError"
      top
      right
    >
      {{ text.isError }}
    </v-snackbar>
    <v-snackbar
      color="success"
      v-model="isSuccess"
      top
      right
    >
      {{ text.isSuccess }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "CustomerSearchDialogVue",
  computed: {
    ...mapGetters({
      searchCustomers: "customer/getSearchCustomers",
    }),
    customerSearchDialogVueDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(data) {
      if (data) {
        this.initData();
      }
    },
  },
  data() {
    return {
      form: {},
      text: {
        title: "CustomerSearchDialogVue",
        isCreate: '',
        isUpdate: '',
        isError: '',
        isSuccess: '',
      },
      searchText: "",
      isError: false,
      isSuccess: false,
      timeOutSearch: null,
      isLoading: false,
    };
  },
  props: {
    value: Boolean,
    objectId: String,
    isDisable: Boolean,
    isUpdate: Boolean,
    isCreate: Boolean,
  },
  created() {
    this.text.isCreate = this.$t('action_type.create');
    this.text.isUpdate = this.$t('action_type.edit');
    this.text.isError = this.$t('save_data_error');
    this.text.isSuccess = this.$t('save_data_finish');
  },
  methods: {
    typeString(val) {
      const data = {
        personal: this.$t('customer.type.personal'),
        company: this.$t('customer.type.company'),
      };
      return data[val] || "-";
    },
    async findCustomer() {
      try {
        if (this.searchText != "") {
          clearTimeout(this.timeOutSearch);
          this.isLoading = true;
          this.timeOutSearch = setTimeout(() => {
            this.$store.dispatch("customer/getCustomerByKeyword", {
              keyword: this.searchText,
            });
            this.isLoading = false;
          }, 1000);
        }
        // this.isSuccess = true;
      } catch (e) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    selectCustomer(customer) {
      this.customerSearchDialogVueDialog = false;
      this.$emit("select", customer);
    },
    async initData() {
      try {
        const params = {};
        this.$store.commit("customer/setSearchCustomer", { customer: [] });
        this.searchText = "";
        this.$emit("onInit");
      } catch (e) {
        console.log(e);
      }
    },
    async saveData() {
      try {
        const params = this.form;
      } catch (e) {
        console.log(e);
      }
    },
    onSave() {
      try {
        const response = this.saveData();
        this.customerSearchDialogVueDialog = false;
        this.$emit("onSave", response);
      } catch (e) {
        console.log(e);
      }
    },
    onCancel() {
      try {
        this.customerSearchDialogVueDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.normal-select {
  @apply transform hover:-translate-x-3 transition-all hover:bg-picton-blue-100 hover:text-picton-blue-600;
}
</style>
